




































import { Component, Vue } from 'vue-property-decorator';
import { ThreadDump, ThreadsResponse } from '@service/solr/admin/info';
import ThreadDumpItem from '@components/thread-dump/ThreadDumpItem.vue';

@Component({
  components: {
    ThreadDumpItem,
  },
})
export default class ThreadDumpView extends Vue {
  private result: ThreadsResponse = {} as ThreadsResponse;
  private loading = false;
  private activeNames: string[] = [];

  created() {
    this.refresh();
  }

  private refresh() {
    this.loading = true;
    this.$service.solr.admin.info
      .threads()
      .then(({ data }) => (this.result = data))
      .catch((err) => this.$notify.error(err.message))
      .finally(() => (this.loading = false));
  }

  private get allNames(): string[] {
    return (
      this.result?.system?.threadDump
        ?.filter((it) => typeof it !== 'string')
        ?.map((it) => it as ThreadDump)
        ?.map((it) => `${it.id}`) || []
    );
  }

  private get threads(): ThreadDump[] {
    return this.result?.system?.threadDump?.filter((it) => typeof it !== 'string').map((it) => it as ThreadDump) || [];
  }
}
